import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import PubItem from "./PubItem";
import styles from "./styles";
import useCRMData from "../../../helpers/use-crm-data";

import Map from "../CgbFindPubResultsBlock/Map";
const useStyles = makeStyles((theme) => styles(theme));

export default function InnsListing() {
  const classes = useStyles();
  const CRMData = useCRMData("Individual Inns");

  const data = useStaticQuery(graphql`
    query InnsListQuery {
      allWpPub(
        filter: { PubData: { brand: { eq: "Individual Inns" } } }
        sort: { fields: title, order: ASC }
      ) {
        nodes {
          PubData {
            featuredImage
            localFile {
              id
              publicURL
              childImageSharp {
                gatsbyImageData(
                  width: 920
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { fit: COVER, cropFocus: CENTER }
                )
              }
            }
            name
            displayLocation
            telephone
            hasOwnWebsite
            url
            tenancyStatus
            crmId
            facilityAccommodation
            latitude
            longitude
            address2
            googlePlaceId
          }
          id
          slug
        }
      }
    }
  `);

  const combinedPubData = data.allWpPub.nodes.map((pub, index) => {
    const id = pub.PubData.crmId;
    const pubFound = CRMData.find((d) => d.id === id);

    return {
      ...pubFound,
      ...pub.PubData,
    };
  });

  let pubs = [];
  data.allWpPub.nodes.map((pub) => {
    pub.PubData.url_featured_image = pub.PubData.featuredImage;
    pub.PubData.id = pub.PubData.crmId;
    pubs.push(pub.PubData);
  });

  const map = (
    <Map
      pubs={pubs}
      firstPub={pubs[0]}
      wpData={data.allWpPub.nodes}
      classes={classes}
      className={classes.Map}
    />
  );

  const [display, setDisplay] = useState("list");
  const showList = function() {
    setDisplay("list");
  };

  const showMap = function() {
    setDisplay("map");
  };

  return (
    <div className={classes.results}>
      <div className="list-filter">
        <span
          onClick={showList}
          className="grid"
          data-active={display === "list"}
        >
          Grid View
        </span>
        <span onClick={showMap} className="map" data-active={display === "map"}>
          Map View
        </span>
      </div>
      {display === "list" && (
        <div className={classes.grid}>
          <Grid container spacing={2} direction="row">
            {combinedPubData.map((pub, index) => {
              return <PubItem classes={classes} pub={pub} key={index} />;
            })}
          </Grid>
        </div>
      )}
      {display === "map" && (
        <div className={classes.map} style={{ width: "100%" }}>
          {map}
        </div>
      )}
    </div>
  );
}
